<template>
    <div>

        <modal-paiement-component v-if="modalPaiment" @closeModal="ClosePaimentModal" :total="total"
            @ShowPayementTap="ShowPayementTap" />


        <div v-if="loading"
            class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60 backdrop-blur-sm">
            <div class="bg-white px-6 py-8 rounded-2xl shadow-lg flex flex-col items-center w-80 text-center">
                <div class="w-10 h-10 border-4 border-yellow-400 border-t-transparent rounded-full animate-spin mb-4">
                </div>
                <p class="text-neutral-900 text-lg font-medium tracking-tight">{{ $t('chargement') }}...</p>
                <p class="text-neutral-500 text-sm mt-2">{{ $t('nouspreparonslasalle') }}</p>
            </div>
        </div>
        <div v-if="showModal"
            class="fixed inset-0 z-[999999] flex justify-center items-center overflow-y-auto px-4 bg-black/40 backdrop-blur-md transition-all">
            <div
                class="w-full max-w-3xl bg-white/10 border border-white/20 backdrop-blur-xl shadow-2xl p-6 md:p-8 rounded-3xl space-y-6 transition-all duration-500">

                <!-- Tabs -->
                <div class="flex space-x-4 mb-6 border-b border-[#e6204b]/60">
                    <button @click="activeTab = 'reservation', step = 1" type="button" :class="[
                        activeTab === 'reservation' ? 'text-[#e6204b] border-b-4 border-[#e6204b]' : 'text-gray-300',
                        'font-semibold pb-2 px-4 transition-all duration-300'
                    ]">
                        
                        {{ $t("informationdelareservation") }}
                    </button>
                    <button @click="activeTab = 'boissons'" type="button" :class="[
                        activeTab === 'boissons' ? 'text-[#e6204b] border-b-4 border-[#e6204b]' : 'text-gray-300',
                        'font-semibold pb-2 px-4 transition-all duration-300'
                    ]">
                        {{ $t("repartitiondestickets") }}
                    </button>
                </div>

                <!-- Onglet Réservation -->
                <div v-if="activeTab === 'reservation'">
                    <h2 class="text-2xl font-semibold text-white mb-4">
                        {{ $t("reserverlatable") }}
                        <span
                            class="text-transparent bg-clip-text font-extrabold bg-gradient-to-r from-[#e6204b] to-[#FF8C42]">
                            {{ selectedTable.numero }} | <span class="text-xl">{{ selectedTable.type }}</span>
                        </span>
                    </h2>

                    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                        <!-- Nom -->
                        <div>
                            <label for="name" class="block text-gray-300">{{ $t('nom') }} <span
                                    class="text-[#e6204b]">*</span></label>
                            <input id="name" v-model="$store.state.reservation.name" type="text"
                                class="w-full mt-2 p-3 rounded-xl bg-white/10 text-white border border-white/20 focus:outline-none focus:ring-2 focus:ring-[#e6204b]"
                                placeholder="Entrez votre nom" required />
                        </div>

                        <!-- Prénom -->
                        <div>
                            <label for="prenom" class="block text-gray-300">{{ $t('prenom') }} <span
                                    class="text-[#e6204b]">*</span></label>
                            <input id="prenom" v-model="$store.state.reservation.prenom" type="text"
                                class="w-full mt-2 p-3 rounded-xl bg-white/10 text-white border border-white/20 focus:outline-none focus:ring-2 focus:ring-[#e6204b]"
                                placeholder="Entrez votre prénom" required />
                        </div>

                        <!-- Email -->
                        <div>
                            <label for="email" class="block text-gray-300">{{ $t('email') }} <span
                                    class="text-[#e6204b]">*</span></label>
                            <input id="email" v-model="$store.state.reservation.email" type="email"
                                class="w-full mt-2 p-3 rounded-xl bg-white/10 text-white border border-white/20 focus:outline-none focus:ring-2 focus:ring-[#e6204b]"
                                placeholder="Entrez votre email" required />
                        </div>

                        <!-- Nombre de places -->
                        <div>
                            <label for="seats" class="block text-gray-300">{{ $t('nombredeplaces') }} <span
                                    class="text-[#e6204b]">*</span></label>
                            <input id="seats" @change="UpdateTicket" v-model="$store.state.reservation.place"
                                type="number" min="1" :max="selectedTable.capacity"
                                class="w-full mt-2 p-3 rounded-xl bg-white/10 text-white border border-white/20 focus:outline-none focus:ring-2 focus:ring-[#e6204b]"
                                required />
                        </div>

                        <!-- Code promo -->
                        <div class="col-span-full">
                            <label for="promo" class="block text-gray-300">{{ $t('codepromo') }}</label>
                            <div class="flex items-center space-x-2 mt-2">
                                <input id="promo" v-model="$store.state.reservation.codepromo" type="text"
                                    class="flex-1 p-3 rounded-xl bg-white/10 text-white border border-white/20 focus:outline-none focus:ring-2 focus:ring-[#e6204b]"
                                    placeholder="Entrez votre code promo" />
                                <div v-if="loadingCodePromo"
                                    class="w-10 h-10 border-4 border-t-[#e6204b] border-gray-300 rounded-full animate-spin">
                                </div>
                                <button v-else type="button" @click="VerifiedCodePromo"
                                    class="px-4 py-2 bg-[#e6204b] text-white rounded-lg hover:bg-[#FF8C42] transition">
                                    {{ $t('appliquer') }}
                                </button>

                            </div>
                        </div>
                    </div>
                </div>

                <!-- Onglet repartition de ticket -->
                <div v-if="activeTab === 'boissons'">
                    <h2 class="text-2xl font-semibold text-white mb-4">
                        {{ $t('attribuerachaqueticketuneboisson') }}
                    </h2>

                    <div class="grid grid-cols-1 lg:grid-cols-3 gap-4 max-h-64 overflow-y-auto pr-1">
                        <button v-for="(item, index) in tickets" :key="item.id" @click="showTicket(item)" :class="[
                            'p-4 rounded-xl flex justify-between items-center border',
                            index === 0
                                ? 'bg-gradient-to-r from-purple-600 to-indigo-600 border-white/40 shadow-lg scale-[1.02]'
                                : 'bg-white/10 border-white/20'
                        ]">
                            <div class="text-left">
                                <span v-if="item.nom.length > 0" class="text-white font-semibold">{{ item.nom }}</span>
                                <p  v-if="item.nom.length > 0" class="text-gray-400 text-sm">
                                    {{item.boissons.filter(b => b.quantity > 0).length === 0
                                        ? $t('aucuneboisson')
                                        : item.boissons.filter(b => b.quantity > 0).map(b => `${getNom(b.nom)} (${b.quantity}) -
                                    ${b.prix}€`).join(', ')}}
                                </p>
                                <p  v-else class="text-gray-400 text-sm">
                                    {{ "Place "+(index+1) }}
                                </p>
                            </div>
                            <div class="flex items-center space-x-2">
                                <!-- Contenu supplémentaire ici -->
                            </div>
                        </button>

                    </div>
                </div>

                <!-- Chargement -->
                <div v-if="loadingForm" class="flex flex-col items-center space-y-4 pt-4">
                    <div class="w-10 h-10 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
                    <p class="text-white text-sm tracking-wide">{{ $t('payement') }}...</p>
                    <button type="button" @click="closeModal"
                        class="text-white bg-white/10 border border-white/20 px-4 py-1.5 rounded-lg hover:bg-white/20 transition">
                        {{ $t('fermer') }}
                    </button>
                </div>


                <!-- Paiement -->
                <payement-component :data="data" :payment="payement" :paymentStep="paymentStep"
                    @stripeState="stripeState" v-if="payement" @CloseStripeModal="payement = false" />


                <!-- Boutons -->
                <div v-else class="flex justify-end space-x-4 pt-4">
                    <button type="button" @click="nextButton(-1)"
                        class="bg-white/10 border border-white/20 text-white px-4 py-2 rounded-lg hover:bg-white/20 transition">
                        {{ $t('annuler') }}
                    </button>
                    <button type="button" @click="nextButton(1)"
                        class="px-6 py-2 font-semibold rounded-xl shadow-md transition duration-300 ease-in-out" :class="{
                            'bg-gradient-to-r from-[#8B4513] to-[#A0522D] text-white hover:opacity-90': activeTab !== 'boissons',
                            'bg-gradient-to-r from-[#e6204b] to-[#FF8C42] text-black hover:opacity-90': activeTab === 'boissons'
                        }">
                        {{ activeTab === 'boissons' ? $t('confirmer') : $t('continuez') }}
                    </button>
                </div>
            </div>
        </div>

        <div v-if="EditParticipant"
            class="fixed inset-0 z-[9999999] flex justify-center items-center overflow-y-auto px-4 bg-black/40 backdrop-blur-md transition-all">
            <div
                class="w-full max-w-3xl bg-white/10 border border-white/20 backdrop-blur-xl shadow-2xl p-6 md:p-8 rounded-3xl space-y-6 transition-all duration-500">
                <div>
                    <span>{{ $t("quiauraceticket") }} </span>
                </div>
                <div>
                    <label for="name" class="block text-gray-300">{{ $t("nometprenom") }}<span
                            class="text-[#e6204b]">*</span></label>
                    <input id="name" v-model="CurrentTicket.nom" type="text"
                        class="w-full mt-2 p-3 rounded-xl bg-white/10 text-white border border-white/20 focus:outline-none focus:ring-2 focus:ring-[#e6204b]"
                        placeholder="Entrez votre nom" required />
                </div>

                <div class="">
                    <div>
                        <span>
                            {{ $t("attributionuneboissonaceticket") }}
                        </span>
                    </div>
                </div>
                <div class="grid grid-cols-1 lg:grid-cols-3 gap-4 max-h-64 overflow-y-auto pr-1">
                    <div v-for="item in CurrentTicket.boissons" :key="item.id"
                        class="bg-white/10 border border-white/20 p-4 rounded-xl flex flex-col justify-between ">
                        <div>
                            <span class="text-white font-semibold">{{ getNom(item.nom) }}</span>
                            <p class="text-gray-400 text-sm">
                                {{ item.prix == 0 ? "gratuit" : item.prix + " euro" }}
                            </p>
                        </div>
                        <div class="flex  justify-end space-x-2">
                            <div>
                                <button @click="updateBoissonQuantity(item, 1)"
                                    class="px-3 rounded-full bg-red-500 text-white">+</button>
                            </div>
                            <div>
                                <span class="font-semibold rounded-full  text-white">
                                    {{ item.quantity }}
                                </span>
                            </div>
                            <div>
                                <button @click="updateBoissonQuantity(item, -1)"
                                    class="px-3 rounded-full bg-red-500 text-white">-</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="flex justify-end space-x-4 pt-4">
                    <button type="button" @click="EditParticipant = false"
                        class="bg-white/10 border border-white/20 text-white px-4 py-2 rounded-lg hover:bg-white/20 transition">
                        {{ $t('annuler') }}
                    </button>
                    <button type="button" @click="EditTicket"
                        class="px-6 py-2 font-semibold rounded-xl shadow-md transition duration-300 ease-in-out" :class="{
                            'bg-gradient-to-r from-[#8B4513] to-[#A0522D] text-white hover:opacity-90': activeTab !== 'boissons',
                            'bg-gradient-to-r from-[#e6204b] to-[#FF8C42] text-black hover:opacity-90': activeTab === 'boissons'
                        }">
                        {{ activeTab === 'boissons' ? $t('confirmerlareservation') : $t('continuez') }}
                    </button>
                </div>
            </div>
        </div>

        <div v-if="payementTap"
            class="fixed inset-0 z-[9999999] flex items-center justify-center bg-black/30 backdrop-blur-lg">
            <div
                class="bg-white w-full max-w-sm p-8 rounded-3xl shadow-2xl border border-gray-200 transition-all duration-300 ease-in-out">

                <!-- Titre -->
                <h2 class="text-center text-2xl font-semibold text-gray-900 mb-6">{{ $t('choisirunpaiement') }}</h2>

                <!-- Montant -->
                <div class="flex justify-between items-center text-lg text-gray-700 mb-6">
                    <span>{{ $t('total') }}</span>
                    <span class="text-gray-900 font-bold text-xl">{{ total }} €</span>
                </div>

                <!-- Options de paiement -->
                <div class="space-y-3 mb-6">
                    <button @click="paymentMethod = 'one-time', paymentStep = 1" :class="[
                        'w-full py-3 rounded-xl border transition',
                        paymentMethod === 'one-time'
                            ? 'bg-gray-900 text-white'
                            : 'bg-gray-100 text-gray-800 hover:bg-gray-200'
                    ]">
                        {{ $t('paiementenunefois') }}
                    </button>

                    <button @click="paymentMethod = 'two-times', paymentStep = 2" :class="[
                        'w-full py-3 rounded-xl border transition',
                        paymentMethod === 'two-times'
                            ? 'bg-gray-900 text-white'
                            : 'bg-gray-100 text-gray-800 hover:bg-gray-200'
                    ]">
                        {{ $t('paiementen2fois') }}

                        <br>
                        <span v-if="paymentStep = 2" class="text-sm text-gray-500">{{ $t('deuxpaiements') }}</span>

                    </button>
                </div>

                <!-- Affichage du choix -->
                <div v-if="paymentMethod" class="text-center text-sm text-gray-600 mb-4">
                    {{ $t('paiementselectionner') }} :
                    <span class="font-medium text-gray-800">
                        {{ paymentMethod === 'one-time' ? 'en une fois' : 'en deux fois' }}
                    </span>
                </div>

                <!-- Bouton confirmer -->
                <div v-if="paymentMethod" class="mb-4">
                    <button @click="payement = true"
                        class="w-full py-3 rounded-xl bg-black text-white font-medium hover:bg-gray-800 transition">
                        {{ $t('confirmerlepaiement') }}
                    </button>
                </div>

                <!-- Lien annuler -->
                <div class="text-center">
                    <button @click="payementTap = false" class="text-sm text-gray-400 hover:text-gray-600 transition">{{
                        $t('annuler') }}</button>
                </div>
            </div>
        </div>

        <div v-if="showToast" :class="toastClass"
            class="fixed top-5  right-5 p-4 rounded-lg shadow-lg transition-all z-[9999999]">
            <p class="text-white text-sm md:text-md font-semibold">{{ toastMessage }}</p>
        </div>

        <div>
            <div class="w-11/12  mx-auto md:flex space-x-2">
                <div class="h-full w-full md:w-9/12  p-1 md:p-3 space-y-3">
                    <div class="flex justify-center mb-2 md:mb-4">
                        <div
                            class="px-3 md:px-6 py-1 md:py-3 rounded-2xl shadow-lg bg-gradient-to-br from-[#1E2328] to-[#2F3C44] border border-[#3A3F47] backdrop-blur-md">
                            <span class="text-sm md:text-base font-medium tracking-wide text-white/90 select-none">
                                🎬 {{ $t('sceneecran') }}
                            </span>
                        </div>
                    </div>

                    <div class=" ">
                        <!-- staff -->
                        <div
                            class="w-28 md:w-36 h-28  md:h-36 justify-center flex-wrap gap-3 md:gap-2 items-center   flex ">
                            <div v-for="table in staff" :key="table" class="cursor-not-allowed relative group">
                                <!-- Effet lumineux (si tu veux le laisser ou non) -->
                                <div
                                    class="absolute inset-0 bg-gradient-to-r from-[#e6204b] to-[#FF8C42] rounded-full blur-xl opacity-0 group-hover:opacity-70 transition duration-500">
                                </div>

                                <!-- Cercle principal (table grisée) -->
                                <div
                                    class="relative z-10 w-10 md:w-16 h-10 md:h-16 mx-auto bg-[#1A2634] rounded-full flex items-center justify-center border-4 border-[#FF8C42] opacity-50 grayscale">
                                    <h2 class="text-xs md:text-lg font-bold text-white tracking-wider">
                                        {{ table.titre }}
                                    </h2>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="w-full   py-2 md:flex gap-2 md:gap-4 ">
                        <div class="h-full md:w-1/12 flex items-center md:justify-center">
                            <div
                                class="backdrop-blur-md bg-white/20 rounded-2xl shadow-inner border border-white/30 px-2 py-1 md:py-4 flex items-center justify-center">
                                <span
                                    class="text-[10px] text-white tracking-wider uppercase font-light transform  whitespace-nowrap">
                                    {{ $t('issuedesecours') }}
                                </span>
                            </div>
                        </div>
                        <div class="w-[96%] md:w-11/12 h-full space-y-3 ">
                            <div class="flex justify-center items-center w-full">
                                <div v-for="table in vip_non_reserved" :key="table.id"
                                    :class="choisedTicket ? (table.type !== ticketType ? 'opacity-15' : '') : ''"
                                    class="relative w-16 md:w-24 h-16 md:h-24 mx-auto">
                                    <!-- Table VIP -->
                                    <div :class="[
                                        'absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-10 h-7 md:h-11 w-7 md:w-11 rounded-full flex items-center justify-center border-4',
                                        (table.status === 'reserved' || table.capacity === 0)
                                            ? 'bg-gray-300 border-gray-400 opacity-60 cursor-not-allowed'
                                            : 'bg-gradient-to-br from-[#FFD700] via-[#FFA500] to-[#FF8C00] border-yellow-400 cursor-pointer'
                                    ]"
                                        @click="(table.status !== 'reserved' && table.capacity > 0) && openModal(table)">
                                        <h2 class="text-sm md:text-xl font-bold text-white tracking-wider">
                                            {{ table.type.substring(0, 1) }}
                                        </h2>
                                    </div>

                                    <!-- Chaises (toujours 10) -->
                                    <div v-for="i in 10" :key="'chair-' + i" :style="{
                                        top: `${50 + 28 * Math.sin((2 * Math.PI * (i - 1)) / 10)}%`,
                                        left: `${50 + 28 * Math.cos((2 * Math.PI * (i - 1)) / 10)}%`,
                                        transform: 'translate(-50%, -50%)',
                                    }" class="absolute h-2 md:h-3 w-2 md:w-3 rounded-full border border-gray-300"
                                        :class="table.capacity === 0
                                            ? 'bg-gray-400'
                                            : (i <= table.capacity
                                                ? (table.type === 'Early Bird' ? 'bg-blue-300'
                                                    : table.type === 'Last Chance' ? 'bg-gray-300'
                                                        : table.type === 'VIP' ? 'bg-yellow-400'
                                                            : 'bg-green-300')
                                                : 'bg-gray-400')">
                                    </div>
                                </div>


                            </div>
                            <div class="grid grid-cols-7 md:grid-cols-7 gap-2 md:gap-4 ">
                                <div v-for="table in [...regular_except_last_14]" :key="table.id"
                                    class="relative w-16 h-16 md:w-24 md:h-24 mx-auto group" :class="[
                                        choisedTicket && table.type !== ticketType ? 'opacity-15' : '',
                                        table.capacity > 0 ? 'cursor-pointer' : 'cursor-not-allowed opacity-70'
                                    ]" @click="table.capacity > 0 && openModal(table)">
                                    <!-- Cercle principal (table) -->
                                    <div :class="[
                                        'absolute top-1/2 left-1/2 z-10 transform -translate-x-1/2 -translate-y-1/2 rounded-full flex items-center justify-center border-4 shadow-2xl transition-transform duration-500 group-hover:scale-105',
                                        'h-7 md:h-11 w-7 md:w-11',
                                        table.capacity === 0 ? 'bg-gray-600 border-gray-400' : 'bg-green-600 border-green-400'
                                    ]">
                                        <h2 class="text-lg md:text-xl font-bold text-white tracking-wider">
                                            {{ table.titre }}
                                        </h2>
                                    </div>

                                    <!-- Chaises autour -->
                                    <div v-for="i in 10" :key="'chair-' + i" :style="{
                                        top: `${50 + 28 * Math.sin((2 * Math.PI * (i - 1)) / 10)}%`,
                                        left: `${50 + 28 * Math.cos((2 * Math.PI * (i - 1)) / 10)}%`,
                                        transform: 'translate(-50%, -50%)'
                                    }" class="absolute h-2 md:h-3 w-2 md:w-3 rounded-full border border-gray-300"
                                        :class="{
                                            'bg-gray-400': i > table.capacity || table.capacity === 0,
                                            'bg-blue-300': i <= table.capacity,
                                            'bg-gray-300': i <= table.capacity,
                                            'bg-green-300': i <= table.capacity,
                                        }"></div>

                                    <!-- Effet lumineux -->
                                    <div
                                        class="absolute inset-0 bg-gradient-to-r from-[#e6204b] to-[#FF8C42] rounded-full blur-xl opacity-0 group-hover:opacity-70 transition duration-500">
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <div class="w-11/12 md:w-3/12 h-full py-2 flex  px-4">
                    <div class="h-96 bg-blue-400  pt-10 lg:hidden">
                        <p class="rotate-90 inline-block align-middle whitespace-nowrap">place a gauche</p>
                    </div>
                    <div class="flex gap-4 w-full md:w-10/12 ">
                        <div class="mx-auto items-center space-y-4">
                            <div v-for="table in vip_reserved" :key="table.id"
                                :class="choisedTicket ? (table.type !== ticketType ? 'opacity-15' : '') : ''"
                                class="relative w-16 md:w-24 h-16 md:h-24 mx-auto">
                                <!-- Table (centrée) -->
                                <div :class="[
                                    'absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-10 h-7 md:h-11 w-7 md:w-11 bg-gradient-to-br from-[#FFD700] via-[#FFA500] to-[#FF8C00] rounded-full flex items-center justify-center border-4',
                                    table.status === 'reserved'
                                        ? 'bg-gray-300 border-gray-400 opacity-60 cursor-not-allowed'
                                        : 'cursor-pointer'
                                ]" @click="openModal(table)">
                                    <h2 class="text-sm md:text-xl font-bold text-white tracking-wider">
                                        {{ table.type.substring(0, 1) }}
                                    </h2>
                                </div>

                                <!-- Chaises autour -->
                                <div v-for="(n, i) in table.capacity" :key="'chair-' + i" :style="{
                                    top: `${50 + 28 * Math.sin((2 * Math.PI * i) / table.capacity)}%`,
                                    left: `${50 + 28 * Math.cos((2 * Math.PI * i) / table.capacity)}%`,
                                    transform: 'translate(-50%, -50%)'
                                }" class="absolute h-2 md:h-3 w-2 md:w-3 rounded-full border border-gray-300 bg-gradient-to-br from-[#FFD700] via-[#FFA500] to-[#FF8C00]  "
                                    :class="table.status === 'reserved'
                                        ? 'bg-gray-300 border-gray-400 opacity-60 cursor-not-allowed'
                                        : 'cursor-pointer'"></div>
                            </div>
                        </div>
                        <div class="w-full md:w-8/12 h-full md:-ml-8 -ml-0">
                            <div class="grid grid-cols-2 ">
                                <div v-for="table in last_14_regular" :key="table.id"
                                    class="relative w-16 h-16 md:w-24 md:h-24 mx-auto group" :class="[
                                        choisedTicket && table.type !== ticketType ? 'opacity-15' : '',
                                        table.capacity > 0 ? 'cursor-pointer' : 'cursor-not-allowed opacity-70'
                                    ]" @click="table.capacity > 0 && openModal(table)">
                                    <!-- Cercle principal (table) -->
                                    <div :class="[
                                        'absolute top-1/2 left-1/2 z-10 transform -translate-x-1/2 -translate-y-1/2 rounded-full flex items-center justify-center border-4 shadow-2xl transition-transform duration-500 group-hover:scale-105',
                                        'h-7 md:h-11 w-7 md:w-11',
                                        table.capacity === 0 ? 'bg-gray-600 border-gray-400' : 'bg-green-600 border-green-400'
                                    ]">
                                        <h2 class="text-lg md:text-xl font-bold text-white tracking-wider">
                                            {{ table.titre }}
                                        </h2>
                                    </div>

                                    <!-- Chaises autour -->
                                    <div v-for="i in 10" :key="'chair-' + i" :style="{
                                        top: `${50 + 28 * Math.sin((2 * Math.PI * (i - 1)) / 10)}%`,
                                        left: `${50 + 28 * Math.cos((2 * Math.PI * (i - 1)) / 10)}%`,
                                        transform: 'translate(-50%, -50%)'
                                    }" class="absolute h-2 md:h-3 w-2 md:w-3 rounded-full border border-gray-300"
                                        :class="{
                                            'bg-gray-400': i > table.capacity || table.capacity === 0,
                                            'bg-blue-300': i <= table.capacity && table.type === 'Early Bird',
                                            'bg-gray-300': i <= table.capacity && table.type === 'last chance',
                                            'bg-green-300': i <= table.capacity && table.type === 'Regular',
                                        }"></div>

                                    <!-- Effet lumineux -->
                                    <div
                                        class="absolute inset-0 bg-gradient-to-r from-[#e6204b] to-[#FF8C42] rounded-full blur-xl opacity-0 group-hover:opacity-70 transition duration-500">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PayementComponent from '@/components/stripe/PayementComponent.vue';
import ModalPaiementComponent from '@/components/ModalPaiementComponent.vue';
export default {
    components: {
        PayementComponent,
        ModalPaiementComponent
    },
    created() {
        const ticketType = this.$route.query.ticket;

        const Table = [
            "Early Bird",
            "Last Chance",
            "VIP",
            "Regular",
        ];

        if (ticketType && !Table.includes(ticketType)) {
            this.$router.back();
        } else {
            this.ticketType = ticketType;
            this.choisedTicket = true
            if (this.ticketType == null) this.choisedTicket = false
        }

        this.loading = !this.loading
        this.axios.get(`${this.$store.state.api}/getTablesCategorized/${ticketType}`)
            .then(({ data }) => {
                this.staff = data.staff
                this.vip_non_reserved = data.vip_non_reserved
                this.vip_reserved = data.vip_reserved
                this.last_14_regular = data.last_14_regular
                this.last_chance = data.last_chance
                this.early_bird = data.early_bird
                this.regular_except_last_14 = data.regular_except_last_14
                this.$store.state.boissons = data.boissons
                this.loading = false
            })
            .catch(error => {
                this.loading = false
                console.log(error)
            });
    },
    data() {
        return {
            payementTap: false,
            paymentMethod: false,
            loading: false,
            showModal: false,
            selectedTable: null,
            loadingForm: false,
            reservation: {
                name: '',
                prenom: '',
                email: '',
                place: 1,
                boissons: []
            },
            showToast: false,
            toastMessage: "",
            codepromo: "",
            activeTab: 'reservation',
            payement: false,
            data: "",
            test: false,


            staff: [],
            vip_non_reserved: [],
            vip_reserved: [],
            regular_except_last_14: [],
            last_14_regular: [],
            last_chance: [],
            early_bird: [],
            paymentStep: 1,
            total: 0,
            currentTicket: "",
            ticketType: "",
            choisedTicket: false,
            modalPaiment: false,
            loadingCodePromo: false,
            tickets: [],
            EditParticipant: false,
            CurrentTicket: {
                index: 0,
                nom: "",
                boissons: []
            },

        };
    },
    methods: {

        EditTicket() {
            if (this.CurrentTicket.nom.length > 3) {
                // this.tickets.filter((item,index) => item.index == this.CurrentTicket.index ? console.log(this.CurrentTicket.index + ", " + this.CurrentTicket.boissons[index]) : console.log(false))
                this.tickets.forEach((element, index) => {
                    if (element.index === this.CurrentTicket.index) {
                        this.tickets[index].nom = this.CurrentTicket.nom
                        this.tickets[index].boissons = this.CurrentTicket.boissons
                    }
                });
                this.CurrentTicket.index = 0
                this.CurrentTicket.nom = ""
                this.CurrentTicket.boissons = []
                this.EditParticipant = false
                // console.dir(this.CurrentTicket)
            }
        },

        showTicket(ticket) {
            this.CurrentTicket.index = ticket.index
            this.CurrentTicket.nom = ticket.nom
            this.CurrentTicket.boissons = []
            if (ticket.boissons.length == 0) {
                this.boissons.forEach(boisson => {
                    const item = {
                        id: boisson.id,
                        nom: boisson.nom,
                        type: boisson.type,
                        prix: boisson.prix,
                        quantity: 0
                    }
                    this.CurrentTicket.boissons.push(item);
                });
            } else {
                this.CurrentTicket.boissons = ticket.boissons
            }
            this.EditParticipant = true
        },

        showToastMessage(message, className) {
            this.toastMessage = message;
            this.toastClass = className;
            this.showToast = true;
            // if (className != 'bg-[#e6204b]') this.$refs.audio.play();
            setTimeout(() => {
                this.showToast = false;
            }, 3000);
            // Hide toast after 3 seconds
        },
        openModal(table) {
            if (table.capacity === 0 || table.status == 'reserved') {
                this.showToastMessage("les places de cette table sont tous occupees", "bg-[#e6204b]");
            } else {
                this.loading = !this.loading
                this.axios.get(`${this.$store.state.api}/getTicketForTable/${table.numero}`)
                    .then(({ data }) => {
                        this.currentTicket = data
                        this.loading = false
                        localStorage.setItem("TICKETSELECTED", JSON.stringify(data))
                        this.selectedTable = table;
                        this.$store.state.reservation.tableId = table.id;
                        this.showModal = true;
                        this.reservation.place = 1;
                        this.$store.state.reservation.boissons = this.boissons.map(boisson => ({ ...boisson, quantity: 0 }));
                    })
                    .catch(error => {
                        this.loading = false
                        console.log(error)
                    });
            }
        },
        closeModal() {
            this.showModal = false;
            this.loadingForm = false
            this.activeTab == "reservation"
            this.payement = false
            this.selectedTable = null;
            this.$store.state.reservation.email = ""
            this.$store.state.reservation.name = ""
            this.$store.state.reservation.prenom = ""
            this.$store.state.reservation.place = 1
            this.$store.state.reservation.boissons = []
        },
        updateBoissonQuantity(boisson, change) {
            // console.dir(change)
            const index = this.CurrentTicket.boissons.findIndex(b => b.id === boisson.id);
            if (index !== -1) {
                this.CurrentTicket.boissons[index].quantity = Math.max(0, this.CurrentTicket.boissons[index].quantity + change);
            }
        },
        nextButton(index) {
            if (this.activeTab === "reservation" && index === -1) {
                this.closeModal();
            } else if (
                this.$store.state.reservation.email.length === 0 ||
                this.$store.state.reservation.name.length === 0
            ) {
                this.showToastMessage("Veuillez remplir tous les champs", 'bg-[#e6204b]');
            } else {
                if (this.activeTab === "reservation" && index === 1) {
                    // ➤ Passage au formulaire Boissons
                    if (this.tickets.length == 0) {
                        this.UpdateTicket();
                    }
                    if (this.$store.state.reservation.codepromo.length > 0) {
                        this.VerifiedCodePromo();
                    }
                    this.activeTab = "boissons";
                    console.log("Passage au formulaire Boissons");

                } else if (this.activeTab === "boissons" && index === -1) {
                    // ➤ Retour à Réservation
                    this.activeTab = "reservation";
                    console.log("Retour au formulaire Réservation");

                } else if (this.activeTab === "boissons" && index === 1) {
                    // // ➤ Soumission finale — calcul total et affichage modal paiement
                    this.data = this.$store.state.reservation;
                    this.data.total = this.calculerTotal(
                        this.currentTicket,
                        this.data.place,
                        this.tickets,
                        this.$store.state.reservation.codepromo.length > 0
                            ? this.$store.state.reservation.codepromo
                            : 0
                    );
                    this.total = this.data.total;


                    console.log("Formulaire boissons complété → Modal paiement lancé");


                    // verifier que les tickets sont remplis
                    let allTicketsFilled = true;
                    this.tickets.forEach(ticket => {
                        if (ticket.nom.length < 3) {
                            allTicketsFilled = false;
                        }
                    });
                    if (!allTicketsFilled) {
                        this.showToastMessage("Veuillez remplir tous les champs des tickets", 'bg-[#e6204b]');
                    } else {
                        this.$store.state.reservation.tickets = this.tickets;
                        this.modalPaiment = true;
                    }


                }
            }

        },
        confirmPayment() {
            this.payement = true
        },
        calculerTotal(ticket, place, tickets, codepromo) {
            let total = 0;
            let ticketPrice = ticket.price * place;

            let totalBoissons = 0;
            tickets.forEach(ticket => {
                ticket.boissons.forEach(boisson => {
                    if (boisson.quantity > 0) {
                        totalBoissons += boisson.prix * boisson.quantity;
                    }
                });
            });

            total = ticketPrice + totalBoissons;

            console.log("Total avant code promo:", total);

            if (codepromo && codepromo.length > 0) {
                total = total * 0.9; // 10% de réduction
            }

            console.log("Total après code promo:", total);

            return total.toFixed(2);
        },
        stripeState(state) {
            console.log(state)
        },

        ShowPayementTap() {
            this.payement = true;
        },

        ClosePaimentModal() {
            this.modalPaiment = false;
            this.payement = false;
        },

        VerifiedCodePromo() {
            if (this.$store.state.reservation.codepromo.length > 0) {
                this.loadingCodePromo = true;
                let data = new FormData();
                data.append("codepromo", this.$store.state.reservation.codepromo);
                data.append("_method", "GET");
                this.axios.post(`${this.$store.state.api}/VerifiedCodePromo`, data)
                    .then(({ data }) => {
                        this.loadingCodePromo = false;
                        console.log(data.valid)
                        if (data.valid) {
                            this.showToastMessage("Code promo valide !", "bg-[#28a745]");
                        } else {
                            this.showToastMessage("Code promo invalide ou expiré", "bg-[#e6204b]");
                        }
                    })
                    .catch(error => {
                        this.loadingCodePromo = false;
                        this.$store.state.reservation.codepromo = "";
                        console.error(error);
                        this.showToastMessage("Erreur lors de la vérification du code promo", "bg-[#e6204b]");
                    });
            }
        },

        UpdateTicket() {
            this.tickets = [];
            for (let index = 0; index < this.$store.state.reservation.place; index++) {

                let item = {
                    index: index,
                    nom: index == 0 ? this.$store.state.reservation.name : "",
                    boissons: []
                };

                this.tickets.push(item)
            }
        },
        getNom(nomJson) {
            try {
                const nom = JSON.parse(nomJson);
                return nom[this.$i18n.locale] || nom['fr'];
            } catch {
                return nomJson;
            }
        }
    },
    computed: {
        ticket() {
            return this.$store.state.ticketSelected;
        },
        tables() {
            return this.$store.state.tables;
        },
        boissons() {
            return this.$store.state.boissons;
        },
    }
};
</script>

<!-- Tailwind Components -->